const DEFAULT_API_BASE =
  'http://localhost/henrique_tempus/site_seta/setanovosite/backend';

export const API_BASE = (process.env.REACT_APP_API_BASE || DEFAULT_API_BASE).replace(/\/$/, '');

async function request(path, options = {}) {
  const res = await fetch(`${API_BASE}${path}`, {
    credentials: 'include',
    ...options,
    headers: {
      ...(options.body instanceof FormData ? {} : { 'Content-Type': 'application/json' }),
      ...(options.headers || {}),
    },
  });
  let data = null;
  try {
    data = await res.json();
  } catch {
    data = null;
  }
  if (!res.ok) {
    const err = new Error(data?.error || `Erro HTTP ${res.status}`);
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}

/** Resolve URLs de imagem (absolutas, /news/*, ou uploads no backend). */
export function mediaUrl(path) {
  if (!path) return '';
  if (/^https?:\/\//i.test(path)) return path;
  if (path.startsWith('uploads/')) return `${API_BASE}/${path}`;
  if (path.startsWith('/backend/uploads/')) return `${API_BASE}${path.replace(/^\/backend/, '')}`;
  return path;
}

export function fetchNewsList() {
  return request('/news/list.php').then((d) => d.news || []);
}

export function fetchNewsArticle(slug) {
  return request(`/news/get.php?slug=${encodeURIComponent(slug)}`).then((d) => d.article);
}

export function adminMe() {
  return request('/auth/me.php');
}

export function adminLogin(user, password) {
  return request('/auth/login.php', {
    method: 'POST',
    body: JSON.stringify({ user, password }),
  });
}

export function adminLogout() {
  return request('/auth/logout.php', { method: 'POST', body: '{}' });
}

export function adminListNews() {
  return request('/news/admin-list.php').then((d) => d.news || []);
}

export function adminSaveNews(article) {
  return request('/news/save.php', {
    method: 'POST',
    body: JSON.stringify(article),
  }).then((d) => d.article);
}

export function adminDeleteNews(id) {
  return request('/news/delete.php', {
    method: 'POST',
    body: JSON.stringify({ id }),
  });
}

export async function adminUploadImage(file) {
  const fd = new FormData();
  fd.append('file', file);
  const data = await request('/news/upload.php', { method: 'POST', body: fd });
  return data.url;
}

export function slugify(title) {
  return String(title || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 80);
}

export function estimateReadTime(body) {
  const text = (body || [])
    .filter((b) => b.type === 'p')
    .map((b) => b.text || '')
    .join(' ');
  const words = text.trim().split(/\s+/).filter(Boolean).length;
  const mins = Math.max(1, Math.ceil(words / 200));
  return `${mins} min de leitura`;
}
